// The build-time ts-node caller must not load the browser-only utils barrel.
// eslint-disable-next-line no-restricted-imports
import { trimTrailingSlashes } from '@twisto/utils/trim-trailing-slashes'

// Browser and build callers own the origin, cache and fallback policy.
export const getInstallmentsConfigUrl = (
  apiOrigin: string,
  trailingSlash = true
) =>
  `${trimTrailingSlashes(apiOrigin)}/installments/config${trailingSlash ? '/' : ''}`

export const fetchInstallmentsConfig = async (
  apiOrigin: string,
  options?: RequestInit,
  trailingSlash = true
): Promise<unknown> => {
  const response = await fetch(
    getInstallmentsConfigUrl(apiOrigin, trailingSlash),
    options
  )
  if (!response.ok) {
    throw new Error(
      `Installments configuration request failed: ${response.status}`
    )
  }

  return response.json()
}

export const readInstallmentsLimits = (data: unknown) => {
  if (
    typeof data !== 'object' ||
    data === null ||
    !('minimum_installments_months' in data) ||
    !('maximum_installments_months' in data)
  ) {
    throw new Error('Missing installments limits')
  }
  const min = data.minimum_installments_months
  const max = data.maximum_installments_months
  if (
    typeof min !== 'number' ||
    typeof max !== 'number' ||
    !Number.isSafeInteger(min) ||
    !Number.isSafeInteger(max) ||
    min < 1 ||
    max < min
  ) {
    throw new Error('Invalid installments limits')
  }

  return { min, max }
}
